import { Badge } from '@/components/ui/badge';
import { Reveal } from './Reveal';
import { FEATURES } from './content';

export function Features() {
  return (
    <section id="features" className="scroll-mt-16 border-b border-hairline py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center sm:mb-16">
          <Badge variant="outline" className="mb-4">
            Core capabilities
          </Badge>
          <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
            Everything you need to govern AI spend
          </h2>
          <p className="mt-3 text-base text-muted-foreground">
            Designed with the same discipline you'd expect from your finance
            and security tools.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(({ icon: Icon, title, copy }, i) => (
            <Reveal key={title} delay={(i % 3) * 0.08} className="h-full">
              <div className="glass-card h-full space-y-3 rounded-xl p-6 transition-colors duration-150 ease-out-quart hover:border-border">
                <span className="grid size-9 place-items-center rounded-lg bg-muted/60 text-foreground ring-1 ring-border/60">
                  <Icon className="size-4" />
                </span>
                <div className="space-y-1">
                  <h3 className="text-sm font-semibold tracking-tight">
                    {title}
                  </h3>
                  <p className="text-sm text-muted-foreground">{copy}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
